import { AxiosError } from 'axios';
import customHistory from '../../../utils/customRouter/CustomHistory';
import errorsWhiteList from './axios-error-interceptor-whitelist.json';

export function filterErrorsWhiteList(error: AxiosError) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // If the error case is not whitelisted then navigate to error page
  const filtredErrorsWhiteList = errorsWhiteList.reduce(
    (prev: string, { path, http_status }) =>
      new RegExp(path).test(error?.config?.url ?? '') && http_status.includes(error?.response?.status ?? 0)
        ? path
        : prev,
    '',
  );
  if (!filtredErrorsWhiteList) {
    const uuid = new URLSearchParams(window.location.search).get('subscriptionuuid');
    customHistory.replace(`${process.env.PUBLIC_URL}/oups?subscriptionuuid=${uuid}`, {
      code: `${error?.response?.status}`,
    }); // <-- navigate
  }
  return Promise.reject(error);
}
